
<div class="card">
  <div class="card-header card-header-squirrel">
    <h4>{{this.translate.data['ADDUSER'] | translate}}</h4>
  </div>
  <div class="card-body">
    <form [formGroup]="userForm" novalidate>

      <div class="row">
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <input matInput placeholder="Email" formControlName="email" required>
            @if (!userForm.controls['email'].valid && userForm.controls['email'].touched) {
              <mat-error> {{
              getErrorEmail() }} </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <hr>
        <h5>Benutzer, dessen Rollen übernommen werden sollen:</h5>

        <!-- <div class="row">
        <div class="col-md-12">
          <mat-form-field appearance="fill" >
            <mat-label>{{this.translate.data['SELECTTENANTGROUPROLE'] | translate}}</mat-label>
            <mat-select formControlName="userRoles" multiple>
              <mat-option *ngFor="let role of groupRoles" [value]="role">
                {{role.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="!userForm.controls['userRoles'].valid && userForm.controls['userRoles'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
          </mat-form-field>
        </div>
      </div> -->

      <div class="row">
        <div class="col-md-12">
          @if (!_userSelected) {
            <mat-form-field class="example-full-width">
              <input matInput placeholder="{{this.translate.data['SEARCHUSER'] | translate}}" formControlName="copyUser" [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                (optionSelected)="optionSelected($event)">
                @if (isLoading) {
                  <mat-option class="is-loading">
                    <mat-spinner diameter="50"></mat-spinner>
                  </mat-option>
                }
                @if (!isLoading) {
                  @for (user of users; track user) {
                    <mat-option [value]="user">
                      <span><b>{{ user.userName }}</b> - {{ user.email }}</span>
                    </mat-option>
                  }
                }
              </mat-autocomplete>
            </mat-form-field>
          }
          <!-- <a class="a-color" *ngIf="_userSelected && projectGroupRoleUser.userName != ''">{{projectGroupRoleUser.userName}}</a> -->
          @if (_userSelected && copyUserName != '') {
            <a class="a-color">{{copyUserName}}</a>
          }
        </div>
      </div>

      @if (showInclTGRInfo) {
        <mat-slide-toggle [disabled]="false" [checked]="inclTGR" color="primary" (change)="onChange()">inkl. Mandantengruppen</mat-slide-toggle>
      }
      <!-- <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill" >
          <mat-label>{{this.translate.data['SELECTUSERROLE'] | translate}}</mat-label>
          <mat-select formControlName="userRoles" multiple>
            <mat-option *ngFor="let role of groupRoles" [value]="role">
              {{role.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="!userForm.controls['userRoles'].valid && userForm.controls['userRoles'].touched"> {{this.translate.data['ERRORALERT'] | translate}} </mat-error>
        </mat-form-field>
      </div>
    </div> -->

    <div class="row">
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
        (click)="cancel()" >Abbruch</button>
      </a>
      <span style="flex: 1 1 auto"></span>
      <a>
        <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Projektgruppenrollen auswählen"
        (click)="selectUserPermission()" [disabled]="!isFormValid()">Weiter</button>
      </a>

    </div>
  </form>
</div>
</div>

